import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import Label from "../../../components/Common/Label";
import LoadingDialog from "../../../components/Common/LoadingDialog";
import Notification from "../../../components/Common/Notification";
import SearchBar from "../../../components/Common/Searchbar";
import Table from "../../../components/Common/Table";
import TablePageControl from "../../../components/Common/TablePageControl";
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import CustomSelect2 from "../../../components/Form/CustomSelect2";
import Helpers from "../../../helpers/helpers";
import { deleteShipping, exportShipping, getGeneral, getShippingListing, resetShippingAttachmentState, resetShippingState } from "../../../store/actions";
import "../setting.css";
import RenderPopOverButton from "../../../components/Form/RenderPopOverButton.js";
import DeleteModal from "../../../components/Common/DeleteModal.js";


const ProductShippingSetting = ({ title, exportExcel, shipping, delShipping, userPermission }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const [loading, setIsLoading] = useState(false);
  const [page, setPage] = useState("1");
  const [length, setLength] = useState("50");
  const [keyword, setSearch] = useState("");
  const [sort, setSorted] = useState("asc")
  const [sort_by, setSortBy] = useState("id")
  const [status, setStatus] = useState("all");
  const [selectedRow, setSelectedRow] = useState();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });
  const [creatable, setCreatable] = useState(false);
  const [editable, setEditable] = useState(false);
  const [deletable, setDeletable] = useState(false);
  const [exportable, setExportable] = useState(false);
  const searchRef = useRef(keyword);

  useEffect(() => {
    if (userPermission?.length > 0) {
      userPermission?.includes("create-setting") && setCreatable(true);
      userPermission?.includes("edit-setting") && setEditable(true);
      userPermission?.includes("delete-setting") && setDeletable(true);
      userPermission?.includes("export-setting") && setExportable(true);
      !userPermission?.includes("view-setting") && navigate('/not-authorized');
    }
  }, [userPermission])

  useEffect(() => {
    dispatch(resetShippingState());
  }, [])

  useEffect(() => {
    searchRef.current = keyword;
  }, [keyword]);

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, page, length, sort, sort_by]);

  useEffect(() => {
    if (delShipping?.code === "success") {
      setDeleteOpen(false);
      setNotification({ open: true, msg: "Shipping method deleted successfully", type: "success" });
      dispatch(resetShippingState());
      dispatch(getGeneral());
      setPage("1");
      initData();
    }
    setIsLoading(false);
  }, [delShipping])

  useEffect(() => {
    if (exportExcel?.code === "success") {
      setIsLoading(false)
      Helpers.handleDownloadExcelFile(exportExcel?.excel_base64, 'shipping_methods');
      dispatch(resetShippingAttachmentState());
    }

  }, [exportExcel]);

  const initData = () => {
    dispatch(getShippingListing({
      length: length,
      page: page,
      keyword: searchRef.current,
      status,
      sort: sort,
      sort_by: sort_by
    }))
  }

  const header = [
    {
      Header: "Shipping Method",
      columnID: "id",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <div style={{ paddingRight: "5px" }}>{cellProps.descriptions?.[0]?.title}</div>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Description",
      columnID: "description",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <div style={{ paddingRight: "5px" }}>{cellProps.descriptions?.[0]?.description}</div>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Estimated shipping time",
      columnID: "from_day",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            {
              cellProps?.descriptions?.[0]?.type !== 2 ?
                <div style={{ paddingRight: "5px" }}>
                  {
                    // If from_day exists, show from_day (and to_day if present), otherwise show '-'
                    cellProps.descriptions?.[0]?.from_day
                      ? (
                          cellProps.descriptions?.[0]?.to_day
                            ? (
                                cellProps.descriptions?.[0]?.from_day === cellProps.descriptions?.[0]?.to_day
                                  ? `${cellProps.descriptions?.[0]?.from_day} day(s)`
                                  : `${cellProps.descriptions?.[0]?.from_day} - ${cellProps.descriptions?.[0]?.to_day} day(s)`
                              )
                            : `${cellProps.descriptions?.[0]?.from_day} day(s)`
                        )
                      : '-'
                  }
                </div>
                : '-'
            }
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Status",
      columnID: "status",
      accessor: (cellProps) => {
        return (<React.Fragment><Label.StatusByIDLabel label={cellProps?.status} /></React.Fragment>)
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Action",
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            {editable && <Link to={`/settings-edit-shipping-method/` + (cellProps.id)}>
              <CustomIconButton
                iconName={'ri-pencil-line'}
                onClick={() => ''}
              />
            </Link>}
            <RenderPopOverButton
              items={[{
                iconName: 'ri-delete-bin-line',
                label: 'Delete',
                color: '#ED1A3D',
                permission: deletable,
                onClick: () => { setSelectedRow(cellProps); setDeleteOpen(true) }
              }]}
            />
          </React.Fragment>
        )
      },
      position: 'sticky',
      disableFilters: true,
      filterable: false,
      minWidth: 120
    }
  ]

  const handleDelete = () => {
    if (selectedRow?.id) {
      setIsLoading(true);
      dispatch(deleteShipping({ id: selectedRow?.id }));
    }
  }

  const handleSearch = (text) => {
    setSearch(text);
    setTimeout(() => {
      if (text === searchRef.current) {
        setPage("1");
        initData();
      }
    }, Helpers.searchInterval);
  }

  const handleExport = () => {
    let filter = {
      status: status,
      search: keyword
    }
    Object.keys(filter).forEach(key => {
      if (!filter[key] || filter[key] === 'all') {
        delete filter[key];
      }
    });
    dispatch(exportShipping({
      sort: sort_by,
      sort_order: sort,
      filter: filter
    }));
    setIsLoading(true);
  }

  const resetFilter = () => {
    setPage("1");
    setSearch('');
    setStatus(status === '' ? 'all' : '');
  }

  const customToolsBar = () => {
    return (
      <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
        <Grid container item xs={12} sm={12} md={10} lg={10} spacing={1} className="d-flex align-items-center">
          <Grid item lg={3} md={3} xs={12}>
            <SearchBar
              value={keyword}
              setValue={(e) => handleSearch(e)}
            />
          </Grid>
          <Grid item lg={3} md={3} xs={12}>
            <CustomSelect2 values={status || 'all'} onChange={(e) => { setPage("1"); setStatus(e) }} data={Helpers.status} />
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <CustomButton
              title={'Clear'}
              press={() => resetFilter()}
              height={32}
              backgroundColor={'transparent'}
              textColor={'#7BB9FA'}
            />
          </Grid>
        </Grid>
        {exportable && <Grid item xs={12} sm={12} md={2} lg={2} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }} alignItems={'center'}>
          <CustomButton
            title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
            press={() => handleExport()}
            height={32}
            borderRadius={15}
            borderStyle={"1px solid #babcbe"}
          />
        </Grid>}
      </Grid>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <LoadingDialog open={loading || !shipping?.data} />
        <Container fluid>
          <Notification notification={notification} setNotification={setNotification} />
          <Breadcrumb
            title="Shipping Methods"
            backRoute={'/settings'}
            breadcrumbItems={[{ title: "Settings", link: "/settings" },
            { title: title, link: "#" },
            ]}
          >
            {creatable && <CustomButton
              title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add Shipping Method</>}
              press={() => navigate("/settings-add-shipping-method")}
              height={40}
              backgroundColor={'#101010'}
              textColor={'white'}
            />}
          </Breadcrumb>
          {customToolsBar()}
          <Table
            header={header}
            data={shipping && shipping?.data}
            pageSize={length}
            totalPage={shipping && shipping?.last_page}
            customToolsBar={true}
            sort={sort}
            setSorted={setSorted}
            sort_by={sort_by}
            setSortBy={setSortBy}
          />
          <TablePageControl
            length={length}
            setLength={setLength}
            page={page}
            setPage={setPage}
            totalPage={shipping && shipping?.last_page}
          />
          <DeleteModal
            open={deleteOpen}
            close={() => setDeleteOpen(false)}
            submit={() => handleDelete()}
            module={'shipping method'}
          />
        </Container>
      </div>
    </React.Fragment >
  );
};


function mapStateToProps({ Shipping, Login, }) {
  return {
    shipping: Shipping.shippingListing,
    delShipping: Shipping.deleteShipping,
    userData: Login?.verifyAdmin?.user?.data,
    exportExcel: Shipping.exportShipping,
    userPermission: Login.permissionArry,

  };
}

export default connect(mapStateToProps)(ProductShippingSetting);
